import React from 'react'
import type { WithStyles, MuiTheme as Theme } from '@paintscout/ui'
import { createStyles, withStyles, Typography } from '@paintscout/ui'
import type { FilesGridProps } from '../../FilesGrid'
import FilesGrid from '../../FilesGrid'

export interface FileSectionProps extends WithStyles<typeof styles>, FilesGridProps {
  title: string
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: '0'
    },
    title: {
      marginBottom: `${theme.spacing(1)}px !important`
    }
  })

function FileSection(props: FileSectionProps) {
  const { classes, title, ...filesGridProps } = props

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        {title}
      </Typography>
      <FilesGrid {...filesGridProps} />
    </div>
  )
}

export default withStyles(styles)(FileSection)
